import { singleton, inject } from "tsyringe";

// entities
import type { UserDto } from "@/entities/user/models/dtos";
import { UserBehavior } from "@/entities/user/models/behaviors/UserBehavior";

// features
import { ReadOnlyStudentInputFormConverter } from "@/features/pending-registration/models/converter/ReadOnlyStudentInputFormConverter";
import { ReadOnlyInputFormConverter } from "@/features/pending-registration/models/converter/ReadOnlyInputFormConverter";
import type {
    ReadOnlyStudentInformationInputValue,
    CommonReadOnlyInformationInputValue,
} from "@/features/pending-registration/models/interface";

@singleton()
export class DetailPendingRegistrationService {
    constructor(
        @inject(UserBehavior)
        private readonly userBehavior: UserBehavior,
        @inject(ReadOnlyStudentInputFormConverter)
        private readonly readOnlyStudentInputFormConverter: ReadOnlyStudentInputFormConverter,
        @inject(ReadOnlyInputFormConverter)
        private readonly readOnlyInputFormConverter: ReadOnlyInputFormConverter,
    ) {}

    /**
     * @description 유저 타입에 따라 form data convert
     * @param {UserDto} userDto dto
     * @returns form data
     */
    public convertFormDataByUserType = (
        userDto: UserDto,
    ): ReadOnlyStudentInformationInputValue | CommonReadOnlyInformationInputValue => {
        if (this.userBehavior.isStudent(userDto)) {
            return this.readOnlyStudentInputFormConverter.convert(userDto);
        } else {
            return this.readOnlyInputFormConverter.convert(userDto);
        }
    };
}
